module.exports = __webpack_public_path__ + "static/media/woman-brush.56f342f2.png";